let gradeNameArray = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一年级', '初二年级', '初三年级', '高一年级', '高二年级', '高三年级', '大学一年级', '大学二年级', '大学三年级', '大学四年级']
export default (gradeId) => {
  // let tagYear = Date.now() - new Date(`${gradeId}-09-01`).getTime()
  // let differYear = new Date(tagYear).getFullYear() - 1970
  // let gradeName = gradeNameArray[differYear]

  let nowDate = new Date()
  let curYear = nowDate.getUTCFullYear()
  let month = nowDate.getMonth() + 1
  let day = nowDate.getDate()
  let idx = null

  if (curYear === gradeId) {
    idx = 0
  } else {
    if (month < 8) {
      idx = curYear - (gradeId + 1)
    } else {
      if (day < 10) {
        idx = curYear - (gradeId + 1)
      } else {
        idx = curYear - gradeId
      }
    }
  }

  return gradeNameArray[idx]
}
